import React from 'react';
import _sharedStylesRaw from './ClubShared.module.css';
const sharedStyles = (typeof _sharedStylesRaw === 'object' && _sharedStylesRaw !== null) ? _sharedStylesRaw : {};
import styles from './ClubStreakForm.module.css';

export default function ClubStreakForm({ streak, variant }) {
    const results = Array.isArray(streak) ? streak.slice(-10) : [];
    const count = results.length || 1;

    const summary = [
        { label: 'Won', value: results.filter(r => r === 'W').length },
        { label: 'Lost', value: results.filter(r => r === 'L').length },
        { label: 'Draw', value: results.filter(r => r === 'D').length }
    ];

    const getYPercent = (res) => {
        if (res === 'W') return 10;
        if (res === 'D') return 40;
        return 70;
    };

    const step = 335 / count;
    const startX = step / 2;
    const markerMiddleOffset = 9;

    const points = results.map((r, i) => ({
        x: startX + (i * step),
        y: getYPercent(r) + markerMiddleOffset
    }));

    const generateWavePath = (pts) => {
        if (pts.length < 2) return '';
        let d = `M ${pts[0].x},${pts[0].y}`;
        
        for (let i = 0; i < pts.length - 1; i++) {
            const curr = pts[i];
            const next = pts[i + 1];
            const cp1x = curr.x + (next.x - curr.x) / 2;
            const cp2x = next.x - (next.x - curr.x) / 2;
            d += ` C ${cp1x},${curr.y} ${cp2x},${next.y} ${next.x},${next.y}`;
        }
        return d;
    };

    const wavePath = generateWavePath(points);

    return (
        <section className={sharedStyles.section}>
            <h2 className={sharedStyles.sectionTitle}>Streak Form</h2>
            <div className={styles.formPanel}>
                <div className={styles.formSummary}>
                    {summary.map((item) => (
                        <span key={item.label}>
                            {item.label} <strong>{item.value}</strong>
                        </span>
                    ))}
                </div>
                <div className={styles.formChart}>
                    <svg viewBox="0 0 335 100" preserveAspectRatio="none" className={styles.trendSvg}>
                        {results.map((_, i) => {
                            const x = startX + (i * step);
                            return <line key={i} x1={x} y1="0" x2={x} y2="100" className={styles.guideLine} />;
                        })}
                        <path d={wavePath} className={styles.trendLine} />
                    </svg>

                    <div
                        className={styles.resultMarkers}
                        style={{ gridTemplateColumns: `repeat(${count}, 1fr)` }}
                    >
                        {results.map((result, index) => (
                            <div
                                className={styles.markerWrapper}
                                key={index}
                                style={{
                                    position: 'absolute',
                                    left: `${(index * 100 / count)}%`,
                                    width: `${100 / count}%`,
                                    top: `${getYPercent(result)}%`
                                }}
                            >
                                <span className={styles[`result${result}`]}>
                                    {result}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div
                        className={styles.axisLabels}
                        style={{ gridTemplateColumns: `repeat(${count}, 1fr)` }}
                    >
                        {results.map((_, i) => <span key={i}>{i + 1}</span>)}
                    </div>
                </div>
            </div>
        </section>
    );
}
